import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Modal } from './ui/Modal';

interface PresetResetModalProps {
  isOpen: boolean;
  presetLabel: string;
  hasExtraTab: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const PresetResetModal: React.FC<PresetResetModalProps> = ({
  isOpen,
  presetLabel,
  hasExtraTab,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col items-center text-center gap-4 pt-2">
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-amber-100">
          <AlertTriangle className="text-amber-600" size={24} />
        </div>

        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-1">
            Apply "{presetLabel}" preset?
          </h3>
          <p className="text-sm text-gray-500">
            This will overwrite the mortgage terms in all your calculator tabs with the{' '}
            <span className="font-medium text-gray-700">{presetLabel}</span> defaults.
            {hasExtraTab && (
              <span> Any extra tabs beyond the first two will also be <span className="font-medium text-gray-700">removed</span>.</span>
            )}{' '}
            This cannot be undone.
          </p>
        </div>

        <div className="flex gap-3 w-full pt-2">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500 transition-colors"
          >
            Keep my data
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2 text-sm font-medium text-white bg-amber-600 border border-transparent rounded-md hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-amber-500 transition-colors"
          >
            Apply preset
          </button>
        </div>
      </div>
    </Modal>
  );
};
